<template>
  <div class="main-menu">

    <div class="main-menu-flex-wrapper">

      <div class="back-button" @click="historyBack()"><i class="fal fa-undo"></i></div>

      <!-- HEM -->
      <!-- <router-link class="menu-item-wrapper" :to="{ name: 'Dashboard' }" :class="{ 'is-active': isMenuActive('dashboard') }">
        <div class="menu-item">
          <i class="fal fa-home menu-item-icon dismiss-outside-click"></i>
          <div class="menu-item-text dismiss-outside-click">Start</div>
        </div>
      </router-link> -->

      <!-- KUND -->
      <router-link v-if="hasRole(['Staff']) && hasPermission('EditCustomers')" class="menu-item-wrapper" :to="{ name: 'Customers' }" :class="{ 'is-active': isMenuActive('customers') || isMenuActive('customerlicenses'), 'is-sub': isMenuActive('customerlicenses') }">
        <div class="menu-item" @click="resetFilter('customers')">
          <i class="fal fa-building menu-item-icon dismiss-outside-click"></i>
          <div class="menu-item-text dismiss-outside-click">Kunder</div>
          <div v-if="isMenuActive('customerlicenses')" class="menu-item-text dismiss-outside-click" style="font-size: 0.7rem;">Licenser</div>
        </div>
      </router-link>

      <!-- LICENS -->
      <router-link v-if="hasRole(['Staff']) && hasPermission('EditLicenses')" class="menu-item-wrapper" :to="{ name: 'Licenses' }" :class="{ 'is-active': isMenuActive('licenses') }">
        <div class="menu-item" @click="resetFilter('licenses') && resetFilter('customerlicenses')">
          <i class="fal fa-file-certificate menu-item-icon dismiss-outside-click"></i>
          <div class="menu-item-text dismiss-outside-click">Licenser</div>
        </div>
      </router-link>

      <!-- ÅTERFÖRSÄLJARE -->
      <router-link v-if="hasRole(['Staff']) && hasPermission('EditCustomers')" class="menu-item-wrapper" :to="{ name: 'Resellers' }" :class="{ 'is-active': isMenuActive('resellers') || isMenuActive('resellercustomers'), 'is-sub': isMenuActive('resellercustomers') }">
        <div class="menu-item" @click="resetFilter('resellers')">
          <i class="fal fa-chevrons-right menu-item-icon dismiss-outside-click"></i>
          <div class="menu-item-text dismiss-outside-click">Återförsäljare</div>
          <div v-if="isMenuActive('resellercustomers')" class="menu-item-text dismiss-outside-click" style="font-size: 0.7rem;">Kunder</div>
        </div>
      </router-link>

      <!-- INSTÄLLNINGAR -->
      <div class="menu-item-wrapper">
        <div class="sub-menu" v-if="activeSubMenu === 'settings'">
          <router-link v-if="hasPermission('EditUsers')" class="sub-menu-item" to="/superadmin/users"><span @click="resetFilter('users')">Användare</span></router-link>
          <!-- <router-link v-if="hasPermission('EditPriceLists')" class="sub-menu-item" to="/superadmin/price-lists-default"><span @click="resetFilter('priceListDefault')">PL - standard</span></router-link> -->
          <!-- <router-link v-if="hasPermission('EditPriceLists')" class="sub-menu-item" to="/superadmin/price-lists-customer"><span @click="resetFilter('priceListCustomer')">PL - kund</span></router-link> -->
          <!-- <router-link v-if="hasPermission('EditDeliveryTemplates')" class="sub-menu-item" to="/superadmin/delivery-templates"><span @click="resetFilter('deliveryTemplates')">Leverans</span></router-link> -->
          <!-- <router-link v-if="hasPermission('EditTags')" class="sub-menu-item" to="/superadmin/tags">Taggar</router-link> -->
          <router-link v-if="hasPermission('DeveloperTools')" class="sub-menu-item" to="/settings/dev">Dev's Lounge</router-link>
          <!-- <router-link v-if="hasPermission('EditProducts')" class="sub-menu-item" to="/settings/products"><span @click="resetFilter('products')">Produkter</span></router-link> -->
          <!-- <router-link class="sub-menu-item" to="/settings/preferences">Inställningar</router-link> -->
          <router-link v-if="hasPermission('SystemSettings')" class="sub-menu-item" to="/settings/system-settings">System</router-link>
          <hr style="margin:0">
          <div class="sub-menu-item" @click="openUserModal()">Användarprofil</div>
          <div class="sub-menu-item" @click="changePin()">Byt lösenord</div>
          <hr style="margin:0">
          <div class="sub-menu-item" @click="logout()">Logga ut</div>
        </div>
        <div class="menu-item" @click="openSubMenu('settings')">
          <i class="fal fa-cog menu-item-icon dismiss-outside-click"></i>
          <div class="menu-item-text dismiss-outside-click">Inställningar</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState, mapGetters, mapActions } from 'vuex'
import UserPinModal from '@/components/modals/UserPinModal'
import UserModal from '@/components/modals/UserModal'

export default {
  data () {
    return {
      activeSubMenu: null,
      activeMenu: 'home'
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['hasPermission', 'hasRole'])
  },
  methods: {
    ...mapActions('auth', ['logout']),

    changePin () {
      this.$panel(UserPinModal, { user: this.user })
    },

    openUserModal () {
      this.$panel(UserModal, { id: this.user.userId })
    },

    resetFilter (dataType) {
      this.$store.dispatch(dataType + '/resetFilter')
    },

    historyBack () {
      this.$router.go(-1)
    },

    openSubMenu (subMenuName) {
      if (subMenuName === this.activeSubMenu) {
        this.activeSubMenu = null
      } else {
        this.activeSubMenu = subMenuName
      }
    },

    isMenuActive (routeName) {
      return this.$route.name.toLowerCase().startsWith(routeName.toLowerCase())
    },

    hasClass (element, testClass) {
      if ('classList' in element) {
        return element.classList.contains(testClass)
      } else {
        return new RegExp(testClass).exec(element.className)
      }
    }
  },

  created () {
    window.onclick = event => {
      const el = event.target
      if (this.hasClass(el, 'menu-item') || this.hasClass(el, 'dismiss-outside-click')) {
        return
      }
      this.activeSubMenu = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nav/BottomMenu.vue